// src/pages/RecruiterReport.js

import React, {
  useState,
  useEffect,
  useMemo,
} from "react";

import {
  FaFileExcel,
  FaSearch,
} from "react-icons/fa";

import {
  FiRefreshCw,
} from "react-icons/fi";

import * as XLSX from "xlsx";

import dayjs from "dayjs";

import Swal from "sweetalert2";

import {
  getData,
} from "../../../services/FetchNodeservices";

export default function RecruiterReport() {

  // =================================================
  // SESSION
  // =================================================

  const userInfo =
    JSON.parse(
      localStorage.getItem(
        "USER_INFO"
      ) || "{}"
    );

  const adminInfo =
    JSON.parse(
      localStorage.getItem(
        "ADMIN_INFO"
      ) || "{}"
    );

  const adminData =
    JSON.parse(
      localStorage.getItem(
        "ADMIN"
      ) || "{}"
    );

  const loginData =
    JSON.parse(
      localStorage.getItem(
        "LOGIN_USER"
      ) || "{}"
    );

  const loggedUserId =

    userInfo?.id ||

    userInfo?.user_id ||

    adminInfo?.admin_id ||

    adminInfo?.id ||

    adminData?.admin_id ||

    adminData?.id ||

    loginData?.id ||

    loginData?.admin_id ||

    59;

  // =================================================
  // STATES
  // =================================================

  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [page, setPage] =
    useState(1);

  const rowsPerPage = 12;

  const [selectedRows,
    setSelectedRows] =
    useState([]);

  // =================================================
  // FILTERS
  // =================================================

  const [filters,
    setFilters] =
    useState({

      search: "",

      position: "",

      company: "",

      recruiter: "",

      status: "",
    });

  // =================================================
  // COLUMNS
  // =================================================

  const columns = [

    "date",

    "candidateName",

    "email",

    "phone",

    "positionName",

    "company",

    "recruiter",

    "status",
  ];

  // =================================================
  // LOAD REPORT
  // =================================================

  useEffect(() => {

    fetchReport();

  }, []);

  const fetchReport =
    async () => {

      try {

        setLoading(true);

        const res =
          await getData(

            `recruiter-report/fetch?user_id=${loggedUserId}`
          );

        if (res?.status) {

          setData(
            res.data || []
          );

        } else {

          Swal.fire({

            icon: "error",

            title:
              res?.message ||
              "Failed to fetch report",
          });
        }

      } catch (err) {

        console.log(err);

        Swal.fire({

          icon: "error",

          title:
            "Something went wrong",
        });

      } finally {

        setLoading(false);
      }
    };

  // =================================================
  // UNIQUE VALUES
  // =================================================

  const uniqueValues =
    (key) => [

      ...new Set(

        data
          .map(
            (x) =>
              x[key]
          )
          .filter(Boolean)
      ),
    ];

  // =================================================
  // FILTER DATA
  // =================================================

  const filteredData =
    useMemo(() => {

      const term =
        filters.search.toLowerCase();

      return data.filter(
        (row) => {

          const searchMatch =

            Object.values(
              row
            ).some(
              (v) =>

                v &&
                v
                  .toString()
                  .toLowerCase()
                  .includes(
                    term
                  )
            );

          return (

            searchMatch &&

            (!filters.position ||

              row.positionName ===
                filters.position) &&

            (!filters.company ||

              row.company ===
                filters.company) &&

            (!filters.recruiter ||

              row.recruiter ===
                filters.recruiter) &&

            (!filters.status ||

              row.status ===
                filters.status)
          );
        }
      );

    }, [

      data,

      filters,
    ]);

  // =================================================
  // PAGINATION
  // =================================================

  const pageCount =
    Math.ceil(
      filteredData.length /
        rowsPerPage
    ) || 1;

  const paginated =
    filteredData.slice(

      (page - 1) *
        rowsPerPage,

      page *
        rowsPerPage
    );

  // =================================================
  // EXPORT
  // =================================================

  const exportExcel =
    () => {

      const ws =
        XLSX.utils.json_to_sheet(
          filteredData
        );

      const wb =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(

        wb,

        ws,

        "Recruiter Report"
      );

      XLSX.writeFile(

        wb,

        "RecruiterReport.xlsx"
      );
    };

  // =================================================
  // RESET FILTERS
  // =================================================

  const resetFilters =
    () => {

      setFilters({

        search: "",

        position: "",

        company: "",

        recruiter: "",

        status: "",
      });

      setPage(1);
    };

  // =================================================
  // RETURN
  // =================================================

  return (
    <div className="md:ml-72 pt-24 px-4 md:px-6 pb-8 min-h-screen text-slate-800 flex flex-col">

      {/* HEADER */}

      <div
        className="
          flex
          flex-col
          lg:flex-row
          lg:items-center
          lg:justify-between
          gap-4
          mb-5
        "
      >

        <div>

          <h1
            className="
              text-2xl
              font-bold
              text-gray-800
            "
          >
            Recruiter Report
          </h1>

          <p
            className="
              text-sm
              text-gray-500
              mt-1
            "
          >
            Candidate activity & recruiter tracking
          </p>
        </div>

        <div className="flex gap-3">

          <button
            onClick={
              fetchReport
            }
            className="
              bg-white
              border
              border-gray-200
              px-4
              py-2.5
              rounded-2xl
              text-sm
              font-medium
              flex
              items-center
              gap-2
              hover:bg-gray-50
            "
          >

            <FiRefreshCw />

            Refresh
          </button>

          <button
            onClick={
              exportExcel
            }
            className="
              bg-black
              text-white
              px-4
              py-2.5
              rounded-2xl
              text-sm
              font-medium
              flex
              items-center
              gap-2
            "
          >

            <FaFileExcel />

            Export
          </button>
        </div>
      </div>

      {/* FILTERS */}

      <div className="glass-card p-4 mb-5">

        <div
          className="
            grid
            grid-cols-1
            md:grid-cols-5
            gap-3
          "
        >

          {/* SEARCH */}

          <div className="glass-input flex items-center gap-3 rounded-2xl px-4 py-2.5">

            <FaSearch className="text-gray-400" />

            <input
              type="text"
              placeholder="Search..."
              value={
                filters.search
              }
              onChange={(e) => {

                setFilters({

                  ...filters,

                  search:
                    e.target.value,
                });

                setPage(1);
              }}
              className="
                w-full
                outline-none
                text-sm
                bg-transparent
              "
            />
          </div>

          {[
            {
              key:
                "position",

              placeholder:
                "Position",

              values:
                uniqueValues(
                  "positionName"
                ),
            },

            {
              key:
                "company",

              placeholder:
                "Company",

              values:
                uniqueValues(
                  "company"
                ),
            },

            {
              key:
                "recruiter",

              placeholder:
                "Recruiter",

              values:
                uniqueValues(
                  "recruiter"
                ),
            },

            {
              key:
                "status",

              placeholder:
                "Status",

              values:
                uniqueValues(
                  "status"
                ),
            },
          ].map(
            (
              item,
              index
            ) => (

              <select
                key={index}
                value={
                  filters[
                    item.key
                  ]
                }
                onChange={(e) => {

                  setFilters({

                    ...filters,

                    [item.key]:
                      e.target.value,
                  });

                  setPage(1);
                }}
                className="glass-input px-4 py-2.5 rounded-2xl text-sm outline-none"
              >

                <option value="">
                  {
                    item.placeholder
                  }
                </option>

                {item.values.map(
                  (
                    value,
                    i
                  ) => (

                    <option
                      key={i}
                      value={value}
                    >
                      {value}
                    </option>
                  )
                )}
              </select>
            )
          )}
        </div>

        <div className="flex justify-end mt-4">

          <button
            onClick={
              resetFilters
            }
            className="
              border
              border-gray-300
              px-4
              py-2
              rounded-2xl
              text-sm
              hover:bg-gray-50
            "
          >
            Reset Filters
          </button>
        </div>
      </div>

      {/* TABLE */}

      <div className="glass-card flex-1 min-h-0 overflow-hidden">

        <div
          className="
            h-full
            overflow-auto
          "
        >

          <table
            className="
              min-w-[1200px]
              w-full
            "
          >

            <thead className="sticky top-0 z-10 bg-slate-50 dark:bg-slate-800 border-b border-gray-200 dark:border-slate-800">

              <tr>

                <th className="px-5 py-4">
                  <input
                    type="checkbox"
                  />
                </th>

                {columns.map(
                  (head) => (

                    <th
                      key={head}
                      className="
                        px-5
                        py-4
                        text-left
                        text-xs
                        font-semibold
                        text-gray-500
                        uppercase
                        whitespace-nowrap
                      "
                    >
                      {head}
                    </th>
                  )
                )}
              </tr>
            </thead>

            <tbody>

              {loading ? (

                <tr>

                  <td
                    colSpan={9}
                    className="
                      text-center
                      py-20
                      text-gray-500
                    "
                  >
                    Loading...
                  </td>
                </tr>

              ) : paginated.length ===
                0 ? (

                <tr>

                  <td
                    colSpan={9}
                    className="
                      text-center
                      py-20
                      text-gray-500
                    "
                  >
                    No Records Found
                  </td>
                </tr>

              ) : (

                paginated.map(
                  (row) => (

                    <tr
                      key={
                        row.candidate_id
                      }
                      className="
                        border-b
                        border-gray-100
                        hover:bg-gray-50
                      "
                    >

                      <td className="px-5 py-4">

                        <input
                          type="checkbox"
                        />
                      </td>

                      {columns.map(
                        (c) => (

                          <td
                            key={c}
                            className="
                              px-5
                              py-4
                              text-sm
                              whitespace-nowrap
                            "
                          >

                            {c ===
                            "status" ? (

                              <span
                                className={`
                                  px-3
                                  py-1
                                  rounded-full
                                  text-xs
                                  font-medium

                                  ${
                                    String(
                                      row[
                                        c
                                      ]
                                    ).toLowerCase() ===
                                    "joined"

                                      ? "bg-green-100 text-green-700"

                                      : "bg-gray-100 text-gray-700"
                                  }
                                `}
                              >
                                {row[
                                  c
                                ] || "-"}
                              </span>

                            ) : c ===
                              "date" ? (

                              row[
                                c
                              ]

                                ? dayjs(
                                    row[
                                      c
                                    ]
                                  ).format(
                                    "DD-MM-YYYY"
                                  )

                                : "-"

                            ) : (

                              row[
                                c
                              ] || "-"
                            )}
                          </td>
                        )
                      )}
                    </tr>
                  )
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}

      <div
        className="
          flex
          items-center
          justify-between
          mt-4
        "
      >

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="glass-btn px-4 py-2 rounded-2xl text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Prev
        </button>

        <span className="text-sm text-gray-500">
          Page {page} of {pageCount}
        </span>

        <button
          disabled={page === pageCount}
          onClick={() => setPage(page + 1)}
          className="glass-btn px-4 py-2 rounded-2xl text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    </div>
  );
}